import { render, staticRenderFns } from "./AccessManagementModeSwitcher.vue?vue&type=template&id=a032019c"
import script from "./AccessManagementModeSwitcher.vue?vue&type=script&lang=js"
export * from "./AccessManagementModeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a032019c')) {
      api.createRecord('a032019c', component.options)
    } else {
      api.reload('a032019c', component.options)
    }
    module.hot.accept("./AccessManagementModeSwitcher.vue?vue&type=template&id=a032019c", function () {
      api.rerender('a032019c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/spread-viewer-access-options/AccessManagementModeSwitcher.vue"
export default component.exports